export const INDEXED_DB_VERSION_DEV = 1.6;
export const INDEXED_DB_VERSION_PROD = 2.1;